import { apiRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  create(params) {
    const url = apiRoutes.cancellationFeedbacksPath(1);
    return FetchHelpers.post(url, params);
  },
};
